var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "banned-visitors" } },
    [
      _c("supsis-table", {
        attrs: {
          columns: _vm.getColumns(),
          rows: _vm.bannedVisitors.data,
          "bottom-pagination": true,
          "pagination-cursor": _vm.paginationCursor,
          options: _vm.tableOptions,
        },
        on: {
          "cursor-changed": function (cursor) {
            return (_vm.paginationCursor = cursor)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                  },
                  [
                    _c("a-input-search", {
                      staticClass: "search-input",
                      attrs: { placeholder: _vm.$t("message.startFilter") },
                      on: { search: _vm.onSearch },
                      model: {
                        value: _vm.searchText,
                        callback: function ($$v) {
                          _vm.searchText = $$v
                        },
                        expression: "searchText",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { ghost: "" },
                        on: {
                          click: function ($event) {
                            _vm.isBanModalShow = true
                          },
                        },
                      },
                      [
                        _c("md-icon", [_vm._v("add")]),
                        _vm._v(
                          "\n                    Block Manuel\n                "
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("VisitorManuelBanModal", {
        attrs: { "ban-modal-visible": _vm.isBanModalShow },
        on: {
          close: function ($event) {
            _vm.isBanModalShow = false
          },
          update: _vm.refreshTable,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }